import request from "@/api";

export function login(data) {
    return request({
        url: '/api/user/login',
        method: 'post',
        data: data
    })
}

export function logout() {
    return request({
        url: '/api/user/logout',
        method: 'post'
    })
}

export function verifyCode(data) {
    return request({
        url: '/api/user/verifyCode',
        method: 'get',
        params: data
    })
}

export function getRolePermssion() {
    return request({
        url: '/api/user/getUserRolePermissionInfo',
        method: 'get'
    })
}

export function listUser(data) {
    return request({
        url: '/api/user',
        method: 'get',
        params: data
    })
}

export function getUserMenu() {
    return request({
        url: '/api/permission',
        method: 'get'
    })
}

export function changeUserStatus(data) {
    return request({
        url: '/api/user/changeUserStatus',
        method: 'get',
        params: data
    })
}

export function changePassword(data) {
    return request({
        url: '/api/user/changePassword',
        method: 'post',
        data: data
    })
}

export function saveUser(data){    
    return request({
        url: '/api/user/saveUser',
        method: 'post',
        data: data
    })
} 




// export function listUser(query) {
//     return request({
//         url: '/user',
//         method: 'get',
//         params: query
//     })
// }

// export function addUser(data) {
//     return request({
//         url: '/user',
//         method: 'post',
//         data: data
//     })
// }